import { useEffect, useState, useRef, useCallback } from 'react' 
import { OTP_TIMER_DURATION } from './constants'

/**
 * Hook to manage OTP resend timer
 */
export const useOtpTimer = () => {
	const [timer, setTimer] = useState(OTP_TIMER_DURATION)
	const intervalRef = useRef(null)

	useEffect(() => {
		return () => {
			if (intervalRef.current) {
				clearInterval(intervalRef.current)
			}
		}
	}, [])

	const startTimer = useCallback(() => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current)
		}

		setTimer(OTP_TIMER_DURATION)
		intervalRef.current = setInterval(() => {
			setTimer((time) => {
				if (time <= 1) {
					if (intervalRef.current) {
						clearInterval(intervalRef.current)
						intervalRef.current = null
					}
					return 0
				}
				return time - 1
			})
		}, 1000)
	}, [])

	const canResend = timer === 0

	return { timer, startTimer, canResend }
}

